<template>
    <div class="newsVideoWidget">
        <video ref="videoPlayer" class="video-js"></video>
    </div>
</template>
<script>
import videoJs from 'video.js';

export default {
    props: {
        options: {
            type: Object,
            default() {
                return {
                    plugins: {
                        videoJsResolutionSwitcher: {
                            default: 'high',
                            dynamicLabel: true
                        }
                    }
                };
            }
        }
    },
    data() {
        return {
            player: null,
            updateSrc:null
        }
    },
    mounted() {
        this.player = videoJs(this.$refs.videoPlayer, this.options)
    },
    beforeDestroy() {
        if (this.player) {
            this.player.dispose()
        }
    }
}
</script>
<style lang="less">
@import url('~video.js/dist/video-js.min.css');
.newsVideoWidget {
    position: relative;
    width: 100%;
    overflow: hidden;

}

@font-face {
    font-family: VideoJS;
    src: url('~video.js/dist/font/VideoJS.woff') format('woff'),
    url('~video.js/dist/font/VideoJS.ttf') format('truetype'),
    url('~video.js/dist/font/VideoJS.svg') format('svg');
    font-weight: normal;
    font-style: normal;
}

.video-js [class*='icon-']:before {
    font-family: VideoJS;
}

.video-js .vjs-big-play-button {
    font-size: 2em;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    span {
        &:before {
            line-height: 1.4;
        }
    }
}

.video-js,
video {
    width: 100%;
    height: 202px;
}

.vjs-control {
    &:focus {
        outline: none;
    }
}

</style>
